<script setup lang="ts">
import type { ListItemStatus } from 'shared/composables/useListFilters/useListFilters';

interface Props {
  status: ListItemStatus;
}

defineProps<Props>();

// Same status vocabulary the list filters use (useListFilters.listItemStatus),
// so the chip always agrees with what the filter bar matches on.
const CHIP: Record<
  ListItemStatus,
  { label: string; color: string; textColor: string; outline: boolean }
> = {
  completed: {
    label: 'COMPLETED',
    color: 'positive',
    textColor: 'white',
    outline: false,
  },
  in_progress: {
    label: 'IN_PROGRESS',
    color: 'secondary',
    textColor: 'dark',
    outline: false,
  },
  not_started: {
    label: 'NOT_STARTED',
    color: 'grey-7',
    textColor: 'grey-7',
    outline: true,
  },
};
</script>

<template>
  <q-chip
    dense
    size="sm"
    class="text-weight-medium"
    :outline="CHIP[status].outline"
    :color="CHIP[status].color"
    :text-color="CHIP[status].textColor"
    :label="$t(CHIP[status].label)"
  />
</template>
